<template>
  <w-sliding-popup type="setting" ref="slidingPopup" :title="isAddPopup ? '작업 추가' : '작업 수정'" width="600px" @close="close()">
    <div slot="content">
      <!-- 작업 목록 -->
      <div v-if="isAddPopup" class="mr-b25">
        <el-row class="title-bar" type="flex" justify="space-between">
          <div class="vertical-center-box title-h4 dot-title">작업 목록</div>
          <div class="vertical-center-box" align="right">
            <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool"></w-header-search-button>
          </div>
        </el-row>
        <el-table-wrapper ref="jobTable" :column-default="columnDefault" :data="jobList" :columns="jobColumns" :show-search-tool="showSearchTool" :show-custom-header="true"
        row-class-name="c-pointer" highlight-current-row max-height="230" remote @row-click="onRowClick" @condition-change="loadData" pagination :total="total">
        </el-table-wrapper>
      </div>
      <!-- 선택한 작업 정보 -->
      <div class="mr-b25">
        <el-row class="title-bar title-h4 dot-title">선택한 작업 정보</el-row>
        <el-form :model="formData" :rules="rules" ref="triggerJobForm">
          <el-form-item label="작업 이름">
            <el-input v-model="formData.jobName" :disabled="true"></el-input>
          </el-form-item>
          <el-row type="flex" :gutter="15">
            <el-col :span="12">
              <el-form-item prop="failover" label="실패 제어">
                <el-select v-model="formData.failover" style="width: 100%">
                  <el-option v-for="key in ['CONTINUE', 'STOP']" :key="key" :label="key" :value="key"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="executeIndex" label="수행순서">
                <el-input-number style="width: 100%" controls-position="right" :min="0" v-model="formData.executeIndex"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" :disabled="saveButtonDisabled" @click="onSaveButton">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isNil, isEqual, cloneDeep } from 'lodash';
import { columnDefault } from '@/constants/table';
import { EMPTY_TEXT } from '@/utils/string';
import msgUtil from '@/utils/message';
import amsSettingsApi from '@/api/settings/server/ams-settings';


export default {
  name: 'WTriggerJobSettingPopup',
  props: {
    workCountInfo: {
      type: Number,
    },
    selectedTrigger: {
      type: Object,
    },
    selectedJob: {
      type: Object,
    },
  },
  data() {
    return {
      EMPTY_TEXT,
      columnDefault,
      total: 0,
      showSearchTool: false,
      jobColumns: [
        { prop: 'jobName', label: '작업 이름', remoteProp: 'job.job_name', searchable: true, sortable: true },
      ],
      jobList: [],
      formData: {
        jobId: '',
        jobName: '',
        failover: '',
        executeIndex: null,
      },
      rules: {
        failover: [
          { required: true, validator: this.validateFieldInfo, trigger: 'blur' },
        ],
        executeIndex: [
          { required: true, validator: this.validateFieldInfo, trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    isAddPopup() {
      return isNil(this.selectedJob);
    },
    saveButtonDisabled() {
      return !this.isAddPopup && isEqual(this.formData, this.selectedJob);
    },
  },
  methods: {
    isNil,
    open() {
      this.$refs.slidingPopup.visible = true;
      if (!this.isAddPopup) {
        this.formData = cloneDeep(this.selectedJob);
      } else {
        this.$nextTick(() => {
          this.formData.executeIndex = this.workCountInfo;
          this.loadData();
        });
      }
    },
    close() {
      this.jobList = [];
      this.formData = {
        jobId: '',
        jobName: '',
        failover: '',
        executeIndex: null,
      };
      this.$refs.slidingPopup.visible = false;
      this.showSearchTool = false;
      if (this.isAddPopup) {
        this.$refs.jobTable.clearFilter();
      }
      this.$refs.triggerJobForm.resetFields();
    },
    /**
     * 전체 작업 목록 조회
     * @author jeee12
     * @return {[type]} [description]
     */
    loadData() {
      const jobTable = this.$refs.jobTable;
      const tableParams = jobTable.getParameter();
      amsSettingsApi.getJobList(tableParams).then((response) => {
        if (response.data.success) {
          this.jobList = response.data.data;
          this.total = response.data.total;
          if (!isNil(this.jobList)) {
            jobTable.$children[0].setCurrentRow(this.jobList[0]);
            this.onRowClick(this.jobList[0]);
          }
        }
      });
    },
    /**
     * 작업 목록 row click
     * @author jeee12
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    onRowClick(row) {
      [this.formData.jobId, this.formData.jobName, this.formData.failover] = [row.jobId, row.jobName, row.failover];
    },
    onSaveButton() {
      amsSettingsApi.insertTrgJob({ triggerId: this.selectedTrigger.triggerId, ...this.formData }).then((response) => {
        const target = '작업';
        const action = this.isAddPopup ? msgUtil.action.ADD : msgUtil.action.MODIFY;
        if (response.data.success) {
          this.close();
          this.$emit('re-load');
        }
        this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
      });
    },
    validateFieldInfo(rule, value, callback) {
      if (isNil(value) || value === '') {
        callback(new Error('필수 정보입니다.'));
      } else {
        callback();
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/server/AmsSettings/TriggerSetting/popup/TriggerJobSettingPopup.vue